import React from 'react';
import { motion } from 'framer-motion';
import { Truck, Warehouse, Users } from 'lucide-react';
import './AboutSection.css';

const AboutSection = () => {
  const features = [
    {
      icon: <Truck size={32} />,
      title: 'Nationwide Delivery',
      description: 'Fast, reliable delivery across the UK for all your bulk orders.',
    },
    {
      icon: <Warehouse size={32} />,
      title: 'Cash & Carry Hub',
      description: 'Visit our warehouse at 12 Waghorn Road, London, E13 9JQ.',
    },
    {
      icon: <Users size={32} />,
      title: 'Customer Focused',
      description: 'Serving retailers and businesses with unbeatable wholesale deals.',
    },
  ];

  return (
    <section id="about" className="about-section">
      <div className="about-container">
        <motion.h2
          className="about-title"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          About VBC Services LTD
        </motion.h2>
        <motion.p
          className="about-description"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={{ once: true }}
        >
          VBC Services LTD, led by Vairagkumar Chaudhary, is your trusted Cash and Carry partner based in London. From our hub at 12 Waghorn Road, E13 9JQ, we provide top-quality bulk goods at competitive prices to retailers, small businesses, and wholesalers across the UK. Contact us at <a href="mailto:vairagchaudhary98@gmail.com">vairagchaudhary98@gmail.com</a> or call +44 7304 244778 to explore our unbeatable deals!
        </motion.p>

        <div className="about-features">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              className="feature-card"
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: index * 0.2 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.05 }}
            >
              <div className="feature-icon">{feature.icon}</div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </motion.div>
          ))}
        </div>

        <motion.a
          href="#contact"
          className="about-cta"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.8 }}
          viewport={{ once: true }}
        >
          Get in Touch
        </motion.a>
      </div>
    </section>
  );
};

export default AboutSection;